export default "__VITE_ASSET__DdBBUasN__"